import { useCallback, useRef, useState, type ChangeEvent } from 'react';
import {
  selectComposerAttachments,
  type ComposerAttachmentRejection,
} from './attachmentPolicy';

export const useComposerAttachments = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [rejections, setRejections] = useState<ComposerAttachmentRejection[]>(
    []
  );
  const inputRef = useRef<HTMLInputElement>(null);

  const openPicker = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleFilesPicked = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const picked = Array.from(event.target.files ?? []);
      const selection = selectComposerAttachments(files, picked);
      setRejections(selection.rejected);
      setFiles((prev) => [...prev, ...selection.accepted]);
      // Reset so the same file can be re-picked after removal.
      event.target.value = '';
    },
    [files]
  );

  const removeFile = useCallback((index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const clearFiles = useCallback(() => {
    setFiles([]);
    setRejections([]);
  }, []);

  return {
    files,
    rejections,
    inputRef,
    openPicker,
    handleFilesPicked,
    removeFile,
    clearFiles,
  };
};
